"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInterviewAnswerProperty = exports.interviewAnswerPropertyDefinition = void 0;
exports.interviewAnswerPropertyDefinition = {
    view: {
        label: 'Answer',
        style: 'blockquote',
    },
    constraints: [
        {
            name: 'orderedProperties',
            argument: [
                'interview-answer-text',
                'interview-answer-author',
                'interview-answer-link',
            ],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'interview-answer',
};
const isInterviewAnswerProperty = (prop) => {
    return prop.name === exports.interviewAnswerPropertyDefinition.name;
};
exports.isInterviewAnswerProperty = isInterviewAnswerProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW50ZXJ2aWV3LWFuc3dlci5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL2ludGVydmlldy1hbnN3ZXIucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxpQ0FBaUMsR0FBRztJQUMvQyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsUUFBUTtRQUNmLEtBQUssRUFBRSxZQUFZO0tBQ3BCO0lBQ0QsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsbUJBQW1CO1lBQ3pCLFFBQVEsRUFBRTtnQkFDUix1QkFBdUI7Z0JBQ3ZCLHlCQUF5QjtnQkFDekIsdUJBQXVCO2FBQ3hCO1NBQ0Y7S0FDRjtJQUNELElBQUksRUFBRSxtQkFBbUI7SUFDekIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsa0JBQWtCO0NBQ08sQ0FBQTtBQUkxQixNQUFNLHlCQUF5QixHQUFHLENBQUMsSUFBa0IsRUFBbUMsRUFBRTtJQUMvRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUsseUNBQWlDLENBQUMsSUFBSSxDQUFBO0FBQzdELENBQUMsQ0FBQTtBQUZZLFFBQUEseUJBQXlCLDZCQUVyQyJ9